module.exports = __webpack_public_path__ + "static/logo-ted-rogers-ss@2x-c9485e36714091b2f11a7c7f751a61bd.png";